const isTabEvent = (e) => e?.key === 'Tab' || e?.keyCode === 9;
const isArrowDown = (e) => e?.key === 'ArrowDown' || e?.key === 'Down';
const isArrowUp = (e) => e?.key === 'ArrowUp' || e?.key === 'Up';
const isArrowLeft = (e) => e?.key === 'ArrowLeft' || e?.key === 'Left';
const isArrowRight = (e) => e?.key === 'ArrowRight' || e?.key === 'Right';

export const isKeyForward = (e) => {
  if ((isTabEvent(e) && !e.shiftKey)) {
    return true;
  }

  if (isArrowDown(e)) {
    // Prevent page scroll on arrowKey event
    e.preventDefault();
    return true;
  }

  if (isArrowRight(e)) {
    // Prevent page scroll on arrowKey event
    e.preventDefault();
    return true;
  }
  return false;
};

export const isKeyBackward = (e) => {
  if ((isTabEvent(e) && e.shiftKey)) {
    return true;
  }

  if (isArrowUp(e)) {
    // Prevent page scroll on arrowKey event
    e.preventDefault();
    return true;
  }

  if (isArrowLeft(e)) {
    // Prevent page scroll on arrowKey event
    e.preventDefault();
    return true;
  }
  return false;
};
